import { inject } from "@angular/core"

import { ConfigService } from "~services/config.service"

export const configGuard = () => {
  return new Promise<boolean>((resolve) => {
    const configService = inject(ConfigService)
    if (configService.config) {
      resolve(true)
    } else {
      configService.ready?.subscribe(() => {
        resolve(true)
      })
    }
  })
}
